// Drop-in replacement for connected-react-router's `push` action creator.
// Components that dispatch(push("/path")) continue to work unchanged.
import type { To } from "react-router-dom";

import { navigate } from "utils/navigate";

export const push = (to: To, state?: unknown) => () =>
  navigate(to, state ? { state } : undefined);
